/** Calendar dates stay in UTC arithmetic, independent of the browser's DST offset. */
export function specialDietWeek(date: string): string[] {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return []
  }
  const value = new Date(`${date}T00:00:00Z`)
  if (!Number.isFinite(value.getTime()) || value.toISOString().slice(0, 10) !== date) {
    return []
  }
  value.setUTCDate(value.getUTCDate() - ((value.getUTCDay() + 6) % 7))
  return Array.from({ length: 5 }, (_, index) =>
    new Date(value.getTime() + index * 86400000).toISOString().slice(0, 10),
  )
}
